// client/src/pages/AcceptGift.js
import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';

export default function AcceptGift() {
  const navigate = useNavigate();
  const [giftCode, setGiftCode] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');

    const code = giftCode.trim();
    if (!code) {
      setError('Please enter a gift code');
      return;
    }

    // Navigate to the redemption page
    navigate(`/gift/redeem/${code}`);
  };

  return (
    <div className="min-h-screen bg-cream dark:bg-bg-dark transition-colors duration-300">
      <div className="max-w-lg mx-auto px-4 py-16">
        {/* Hero — always dark */}
        <div className="relative overflow-hidden rounded-2xl mb-8 bg-royal-900">
          <div className="absolute inset-0 bg-hero-gradient opacity-80"></div>
          <div className="absolute inset-0" style={{
            background: 'radial-gradient(ellipse at 30% 20%, rgba(212,175,55,0.12) 0%, transparent 50%)'
          }}></div>
          <div className="relative text-center py-10 px-6">
            <div className="text-5xl mb-4">🎉</div>
            <h1 className="font-display text-3xl text-gold mb-2">Accept a Gift</h1>
            <p className="text-white text-base">
              Someone gifted you a subscription! Enter your gift code below to get started.
            </p>
          </div>
        </div>

        {/* Code input */}
        <div className="bg-white dark:bg-royal-800/40 border border-royal-200/30 dark:border-royal-600 rounded-2xl p-6 sm:p-8">
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-base text-royal-900 dark:text-white mb-2 font-medium">Gift Code</label>
              <input
                type="text"
                value={giftCode}
                onChange={(e) => { setGiftCode(e.target.value); setError(''); }}
                placeholder="e.g. gift-85c327d8012de92c"
                className="w-full px-4 py-3 bg-cream dark:bg-royal-800/50 border border-royal-300 dark:border-royal-600 rounded-lg text-base text-royal-900 dark:text-white placeholder-royal-400 dark:placeholder-royal-200 focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-colors font-mono"
                autoFocus
              />
              <p className="text-royal-500 dark:text-royal-200 text-sm mt-2">
                You can find this code in the gift email you received, or ask the person who sent you the gift.
              </p>
            </div>

            {error && (
              <div className="p-3 bg-red-50 dark:bg-red-900/30 border border-red-300 dark:border-red-700 rounded-lg text-red-600 dark:text-red-400 text-sm">
                {error}
              </div>
            )}

            <button
              type="submit"
              className="w-full py-3 bg-gold text-royal-900 font-bold rounded-xl text-base hover:bg-gold-light transition-colors"
            >
              Redeem Gift
            </button>
          </form>

          {/* Divider */}
          <div className="flex items-center gap-3 my-6">
            <div className="flex-1 h-px bg-royal-200/50 dark:bg-royal-700/50"></div>
            <span className="text-royal-400 dark:text-royal-200 text-sm">or</span>
            <div className="flex-1 h-px bg-royal-200/50 dark:bg-royal-700/50"></div>
          </div>

          {/* Gift a subscription link */}
          <div className="text-center">
            <p className="text-royal-500 dark:text-royal-200 text-sm mb-3">Want to gift a subscription to someone else?</p>
            <Link
              to="/gift"
              className="inline-flex items-center gap-2 px-5 py-2.5 border border-royal-300 dark:border-royal-600 text-royal-700 dark:text-royal-200 rounded-lg text-base hover:border-gold/50 hover:text-gold-dark dark:hover:text-gold transition-colors"
            >
              🎁 Gift a Subscription
            </Link>
          </div>
        </div>

        {/* Back link */}
        <div className="text-center mt-6">
          <Link to="/" className="text-royal-500 dark:text-royal-200 hover:text-gold-dark dark:hover:text-gold transition-colors text-sm">
            ← Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}